import { useId, type SelectHTMLAttributes } from 'react';
import { cn } from '@/utils/cn';

export function Select({ label, error, children, className, ...rest }:
  SelectHTMLAttributes<HTMLSelectElement> & { label: string; error?: string | undefined }) {
  const id = useId();
  return (
    <div className="w-full">
      <label htmlFor={id} className="mb-1.5 block text-sm font-medium text-slate-700">{label}</label>
      <select id={id} aria-invalid={error ? true : undefined}
        className={cn('h-11 w-full rounded-xl bg-white px-3 ring-1 ring-slate-300 focus:ring-2 focus:ring-brand-600', className)} {...rest}>
        {children}
      </select>
      {error && <p role="alert" className="mt-1 text-xs font-medium text-red-600">{error}</p>}
    </div>
  );
}
